import { CpOrderInvoicesSearchModel } from './cp_order_invoices_search_types';
import { validPropMultiSelectVM } from '../../../../core/components/validation/ValidInputMultiSelect';
import { validPropRadioTextVM } from '../../../../core/components/validation/ValidInputRadioText';
import { validPropDateVM } from '../../../../core/components/validation/ValidInputDate';
import { validPropCheckboxVM } from '../../../../core/components/validation/ValidCheckbox';
import { validOptionalPropTextVM } from '../../../../core/components/validation/ValidInputText';
import { validPropDroplistTextVM } from '../../../../core/components/validation/ValidInputDroplistText';
import { getLocalToday } from '../../../../core/components/validation/ValidInputDate.utils';
import utilSvc from '../../../../core/utilSvc';
import { getAffs, FEATURE_NAME } from '../../cp_order_invoices_const';

export function cpOrderInvoicesSearchStateVM(options: any = {}, affList: any[] = []): CpOrderInvoicesSearchModel {
    options = options || {};
    const today = getLocalToday();

    // Patch: If RX.val length matches old options but new options are longer, select all
    const rxOpts = options.rxOptions || [];
    let rxVal = options.RX?.val ?? [];
    if (
        Array.isArray(rxVal) &&
        Array.isArray(options.RX?.options) &&
        rxVal.length === options.RX.options.length &&
        rxOpts.length > rxVal.length &&
        rxVal.length > 0
    ) {
        rxVal = rxOpts.map(opt => opt.val);
    }

    const model = {
        // Radio/select
        ReportType: validPropRadioTextVM(
            'ReportType',
            'Report Type',
            options.ReportType?.val ?? 'facility',
            'facility',
            [
                { lbl: 'Facility', val: 'facility' },
                { lbl: 'Program Admin', val: 'programAdmin' },
            ],
        ),
        ProgramAdmin: validPropDroplistTextVM(
            'ProgramAdmin',
            undefined,
            options.ProgramAdmin?.val || 'N/A',
            undefined,
            options.programAdminOptions || [],
        ),
        // Multi-select
        CE: validPropDroplistTextVM('CE', undefined, options.CE?.val || 'N/A', undefined, options.ceOptions || []),
        RX: validPropMultiSelectVM('RX', 'Pharmacies', rxVal, 'RX', rxOpts),
        // Date range
        DateRangeMode: validOptionalPropTextVM(
            'DateRangeMode',
            'Date Range Mode',
            options.DateRangeMode?.val ?? 'MTD',
            '',
            false,
        ),
        StartDate: validPropDateVM('StartDate', 'Start Date', options.StartDate?.val ?? today),
        EndDate: validPropDateVM('EndDate', 'End Date', options.EndDate?.val ?? today),
        // Checkboxes
        OverallocatedOnly: validPropCheckboxVM(
            'OverallocatedOnly',
            'Overallocated Only',
            options.OverallocatedOnly?.val ?? false,
        ),
        RebatesOnly: validPropCheckboxVM('RebatesOnly', 'Rebates Only', options.RebatesOnly?.val ?? false),
        ReconciledOnly: validPropCheckboxVM(
            'ReconciledOnly',
            'Show Reconciled Only',
            options.ReconciledOnly?.val ?? false,
        ),
        // Add other fields as needed
    };

    /**
     * NOTE:
     * Anytime we generate this model, we need to be checking the CE/ProgramAdmin
     * values to restrict the RX options in the dropdown.
     */
    if (model.ReportType?.val === 'facility' && model.CE.val !== 'N/A') {
        let affs = getAffs(affList, FEATURE_NAME);
        affs = utilSvc.aff.findCe(affs, model.CE?.val);

        const rxList = utilSvc.aff.rxList(affs);
        const rxOptions = rxList.map(rx => ({ lbl: rx, val: rx }));

        model.RX.val = rxList;
        model.RX.options = rxOptions;
    } else if (model.ReportType?.val === 'programAdmin' && model.ProgramAdmin.val !== 'N/A') {
        // Step 1: Raw affiliations
        let affs = utilSvc.aff.findStatus(affList || []);
        affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
        affs = utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(FEATURE_NAME));
        const rxAffs = affs.filter(a => a.ProgAdmin === model.ProgramAdmin.val);
        const rxList = utilSvc.aff.rxList(rxAffs);
        const rxOptions = rxList.map(rx => ({ lbl: rx, val: rx }));

        model.RX.val = rxList;
        model.RX.options = rxOptions;
    }
    return model;
}
